export class CalculationsIconsUtil {

    static CalculationImagesMap = {
        'RATE_CALCULATOR': '/app/images/calculations/opportunity_Rate_Reduction.jpg',
        'SAVINGS': '/app/images/calculations/opportunity_Payment_Savings.jpg',
        'EQUITY_CASH_OUT': '/app/images/calculations/opportunity_Cash_Out.jpg',
        'EQUITY_RATE_AND_TERM_REFINANCE': '/app/images/calculations/opportunity_Equity_Growth.jpg',
        'TRIGGER_LEADS': '/app/images/calculations/opportunity_Trigger_Lead.jpg'
    };


    static getIconUrl = (name) => {
        return CalculationsIconsUtil.CalculationImagesMap[name];
    };
}